
import { defineComponent } from 'vue';
import '@/assets/icons/simple-oton-logo.svg?sprite';

export default defineComponent({
  name: 'CommonSpinner',
  components: {},
});
